export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-02.009706e5.png";